module.exports = __webpack_public_path__ + "img/text-align-right.90bfd82f.svg";